import { CACHE_CONFIG_TYPES } from '@intigral/constant';
import { useEffect, useState } from 'react';
import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import { useSelector } from 'react-redux';
import { IStore } from '../interfaces/StoreTypes';

interface TVODHookReturn {
    ppvSubscribedList: any[];
    setPpvSubscribedList: (ppvList: any[]) => void;
}

const usePPVInfo = (): TVODHookReturn => {
    // const ppvSubList = get(CACHE_CONFIG_TYPES.user)?.ppvList ?? [];
    const userSlice = useSelector((state: IStore) => state?.user);
    const ppvSubList = userSlice?.ppvList ?? [];
    const [ppvSubscribedList, setPpvSubscribedList] = useState<any[]>(ppvSubList);

    useEffect(() => {
        if (ppvSubList.length) {
            setPpvSubscribedList(ppvSubList);
        }
    }, [ppvSubList]);

    return {
        ppvSubscribedList,
        setPpvSubscribedList,
    };
};

export default usePPVInfo;
